import baseUrl from "../energyApiHost";
import { callApi } from "./util";

const createAlertWorkOrder = (alertId, workOrderNumber, description) => {
  const url = `${baseUrl}work-orders`;

  const headers = {
    "Content-Type": "application/json"
  };

  const config = {
    headers,
    method: "POST",
    body: JSON.stringify({
      alertId: alertId,
      workOrderNumber: workOrderNumber,
      description: description
    })
  };

  return callApi(url, config);
};

export default {
  createAlertWorkOrder
};
